import React from 'react';
import ExpandableFloatingDropdown from '../common/ExpandableFloatingDropdown';

const Stage = {
    Initial: 0,
    DocumentationOptions: 1,
    TransformOptions: 2,
    AddConfigurationOptions: 3
}

export default class ProjectExpandableFloatingDropdown extends React.Component {

    dropdownRef = null
    state = {
        stage: Stage.Initial
    }

    handleGenerateDocumentationClick = () => {
        this.setState({
            stage: Stage.DocumentationOptions
        });
    }

    handleDocumentationOptionClick = (id) => {
        this.props.onDocumentationOptionClick(id);
        this.closeDropdown();
    }

    handleTransformDocumentClick = () => {
        this.setState({
            stage: Stage.TransformOptions
        });
    }

    handleTransformOptionClick = (id) => {
        this.props.onTransformOptionClick(id);
        this.closeDropdown();
    }

    handleGoBackButtonClick = () => {
        this.setState({
            stage: Stage.Initial
        });
    }

    handleAddConfigurationClick = () => {
        this.setState({
            stage: Stage.AddConfigurationOptions
        });
    }

    handleCreateNewConfigurationButtonClick = () => {
        this.props.onCreateNewConfigurationOptionClick();
        this.closeDropdown();
    }

    handleAddExistingConfigurationButtonClick = () => {
        this.props.onAddExistingConfigurationOptionClick();
        this.closeDropdown();
    }

    closeDropdown() {
        this.dropdownRef.close();

        // Set stage back to initial after close animation is over.
        setTimeout(() => {
            this.setState({stage: Stage.Initial});
        }, 200);
    }

    render() {
        return (
            <ExpandableFloatingDropdown ref={r => this.dropdownRef = r}>
                {this.renderCurrentStageItems()}
            </ExpandableFloatingDropdown>
        )
    }

    renderCurrentStageItems() {
        let items = [];

        switch (this.state.stage) {
            case Stage.Initial: {
                items = [
                    this.props.canSave && (
                        <ExpandableFloatingDropdown.Item key={1}
                                                         onClick={this.props.onSaveClick}>{__('Save')}</ExpandableFloatingDropdown.Item>
                    ),

                    this.props.canDelete && (
                        <ExpandableFloatingDropdown.Item key={2}
                                                         onClick={this.props.onDeleteClick}>{__('Delete')}</ExpandableFloatingDropdown.Item>
                    ),

                    this.props.canCopy && (
                        <ExpandableFloatingDropdown.Item key={3}
                                                         onClick={this.props.onCopyClick}>{__('Copy')}</ExpandableFloatingDropdown.Item>
                    ),
                    this.props.canRevise && (
                        <ExpandableFloatingDropdown.Item key={3}
                                                         onClick={this.props.onReviseClick}>{__('Revise')}</ExpandableFloatingDropdown.Item>
                    ),
                    <ExpandableFloatingDropdown.Divider key={6}></ExpandableFloatingDropdown.Divider>,
                    <ExpandableFloatingDropdown.Item key={7}
                                                     onClick={this.handleGenerateDocumentationClick}>{__('Generate documentation')}</ExpandableFloatingDropdown.Item>,
                    <ExpandableFloatingDropdown.Item key={8}
                                                     onClick={this.handleTransformDocumentClick}>{__('Transform')}</ExpandableFloatingDropdown.Item>,

                    this.props.canAddConfiguration &&
                    <ExpandableFloatingDropdown.Divider key={4}></ExpandableFloatingDropdown.Divider>,
                    this.props.canAddConfiguration && <ExpandableFloatingDropdown.Item key={5}
                                                                                       onClick={this.handleAddConfigurationClick}>{__('Add configuration')}</ExpandableFloatingDropdown.Item>,
                ];

                break;
            }

            case Stage.DocumentationOptions: {
                items = [
                    ...this.props.documentationOptions.map((x, idx) => (
                        <ExpandableFloatingDropdown.Item key={10 + idx}
                                                         onClick={() => this.handleDocumentationOptionClick(x.id)}>{x.label}</ExpandableFloatingDropdown.Item>
                    )),

                    <ExpandableFloatingDropdown.Divider key={88}></ExpandableFloatingDropdown.Divider>,
                    <ExpandableFloatingDropdown.Item key={99}
                                                     onClick={this.handleGoBackButtonClick}>{__('Go back')}</ExpandableFloatingDropdown.Item>,
                ];

                break;
            }

            case Stage.TransformOptions: {
                items = [
                    ...this.props.transformOptions.map((x, idx) => (
                        <ExpandableFloatingDropdown.Item key={10 + idx}
                                                         onClick={() => this.handleTransformOptionClick(x.id)}>{x.label}</ExpandableFloatingDropdown.Item>
                    )),

                    <ExpandableFloatingDropdown.Divider key={88}></ExpandableFloatingDropdown.Divider>,
                    <ExpandableFloatingDropdown.Item key={99}
                                                     onClick={this.handleGoBackButtonClick}>{__('Go back')}</ExpandableFloatingDropdown.Item>,
                ];

                break;
            }

            case Stage.AddConfigurationOptions: {
                items = [
                    <ExpandableFloatingDropdown.Item key={1}
                                                     onClick={this.handleCreateNewConfigurationButtonClick}>{__('Create new configuration')}</ExpandableFloatingDropdown.Item>,
                    <ExpandableFloatingDropdown.Item key={1}
                                                     onClick={this.handleAddExistingConfigurationButtonClick}>{__('Add existing configuration')}</ExpandableFloatingDropdown.Item>,

                    <ExpandableFloatingDropdown.Divider key={88}></ExpandableFloatingDropdown.Divider>,
                    <ExpandableFloatingDropdown.Item key={99}
                                                     onClick={this.handleGoBackButtonClick}>{__('Go back')}</ExpandableFloatingDropdown.Item>,
                ];

                break;
            }
        }

        return items;
    }
}